import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CommonHeader } from "./common-header";
import { LocalStorageService } from "src/app/utility/localStorageService";
import { ExceptionHandler } from "./errorhandler";
import { catchError, Observable } from 'rxjs';

@Injectable({
    providedIn: "root",
})
export class MonitoringService {

    commonHeader: CommonHeader = new CommonHeader();
    private options = this.commonHeader.options;
    private base = `${environment.serviceRoot}`;

    constructor(
        private http: HttpClient,
        private localStorage: LocalStorageService,
        private ehandler: ExceptionHandler
    ) {}

    /** GET Aggregated App Logs */
    getApp(): Observable<any> {
        this.localStorage.set("method", "Read");
        this.localStorage.set("operation", "App Logs");

        return this.http
            .get<any>(`${this.base}/app`, this.options)
            .pipe(catchError(this.ehandler.errorHandler));
    }

    /** GET Aggregated Apache Logs */
    getApache(): Observable<any> {
        this.localStorage.set("method", "Read");
        this.localStorage.set("operation", "Apache Logs");

        return this.http
            .get<any>(`${this.base}/apache`, this.options)
            .pipe(catchError(this.ehandler.errorHandler));
    }

    /** GET Aggregated System Logs */
    getSystem(): Observable<any> {
        this.localStorage.set("method", "Read");
        this.localStorage.set("operation", "System Logs");

        return this.http
            .get<any>(`${this.base}/system`, this.options)
            .pipe(catchError(this.ehandler.errorHandler));
    }
}
